export default [
  {
    name: 'feed',
    path: '/feed',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Feed',
      icon: 'dvr',
      label: 'Feed'
    }
  }
]
